import { quSave } from '@/service/question'
import iconSrc from '@/assets/images/edit/config/ico-lef-mess@2x.png'
export default {
  id: '',
  groupId: '',
  belongId: '',
  isRequired: '1',
  orderById: 70,
  elementType: 'InfoBox',
  elementDesc: '信息题',
  type: 'infobox',
  config: true,
  title: '信息题',
  quNote: '',
  placeholder: '信息题',
  maxLength: 120,
  value: '',
  toolbar: {
    config: false
  },
  saveUrl: '/design/qu-title/ajaxSave.do',
  iconStyle: {
    width: '11px',
    height: '11px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
    }, this)
  },
  valid: false
}



// WEBPACK FOOTER //
// ./src/components/editor/InfoBox/config.js